<script setup lang="ts"></script>

<template>
  <h1>This folder is locked</h1>
</template>
